import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { apiSlices } from './apis';
import { settingsPersistence } from './Settings/settingsPersistence';
import { rootReducer } from './rootReducer';
import { sessionMiddleware } from './sessionMiddleware';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) =>
    getDefault({
      // Document uploads are FormData bodies, which the serializable check flags on every
      // such mutation — the warning storm buries the real ones.
      serializableCheck: false
    })
      .prepend(settingsPersistence.middleware)
      .concat(...apiSlices.map((api) => api.middleware), sessionMiddleware)
});

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;

// NOTE: tracks window focus so `skipPollingIfUnfocused` can pause polls; nothing uses refetchOnFocus.
setupListeners(store.dispatch);
